import React, { useState } from "react";
import { motion } from "framer-motion";
import { Calendar, Users, Clock, AlertCircle } from "lucide-react";

const AttendanceReportsPage = () => {
  // Mock Data
  const monthlyStats = [
    { month: "Jan", percentage: 85 },
    { month: "Feb", percentage: 88 },
    { month: "Mar", percentage: 82 },
    { month: "Apr", percentage: 90 },
  ];

  return (
    <div className="min-h-screen bg-gray-900 p-6">
      <motion.div
        className="max-w-7xl mx-auto space-y-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        {/* Header */}
        <div className="flex items-center gap-3">
          <div className="p-3 bg-gradient-to-br from-teal-600 to-cyan-600 rounded-2xl shadow-lg shadow-teal-500/20">
            <Calendar className="w-7 h-7 text-white" />
          </div>
          <h1 className="text-4xl font-bold bg-gradient-to-br from-teal-400 to-cyan-400 bg-clip-text text-transparent">
            Attendance Reports
          </h1>
        </div>

        {/* Overview Cards */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700">
            <div className="flex items-center gap-2 mb-2">
              <Users className="w-5 h-5 text-blue-400" />
              <span className="text-gray-400 text-sm">Avg. Present</span>
            </div>
            <p className="text-2xl font-bold text-white">88%</p>
          </div>
          <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700">
            <div className="flex items-center gap-2 mb-2">
              <AlertCircle className="w-5 h-5 text-red-400" />
              <span className="text-gray-400 text-sm">Avg. Absent</span>
            </div>
            <p className="text-2xl font-bold text-white">8%</p>
          </div>
          <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700">
            <div className="flex items-center gap-2 mb-2">
              <Clock className="w-5 h-5 text-orange-400" />
              <span className="text-gray-400 text-sm">Late Comers</span>
            </div>
            <p className="text-2xl font-bold text-white">3%</p>
          </div>
          <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700">
            <div className="flex items-center gap-2 mb-2">
              <Calendar className="w-5 h-5 text-purple-400" />
              <span className="text-gray-400 text-sm">Leaves</span>
            </div>
            <p className="text-2xl font-bold text-white">1%</p>
          </div>
        </div>

        {/* Main Content Area */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Chart */}
          <div className="lg:col-span-2 bg-gray-800 rounded-2xl p-6 border border-gray-700 h-96 flex items-center justify-center">
            <p className="text-gray-500">
              Monthly Attendance Graph Placeholder
            </p>
          </div>

          {/* Low Attendance List */}
          <div className="bg-gray-800 rounded-2xl p-6 border border-gray-700">
            <h3 className="text-lg font-semibold text-white mb-4 flex items-center gap-2">
              <AlertCircle className="w-5 h-5 text-red-400" />
              Low Attendance Alert
            </h3>
            <div className="space-y-4">
              {/* Mock Items */}
              {[1, 2, 3].map((i) => (
                <div
                  key={i}
                  className="flex items-center justify-between p-3 bg-red-500/10 border border-red-500/20 rounded-xl"
                >
                  <div>
                    <p className="text-white font-medium">Student Name {i}</p>
                    <p className="text-red-400 text-xs">Batch A</p>
                  </div>
                  <span className="font-bold text-red-500">65%</span>
                </div>
              ))}
            </div>
            <button className="w-full mt-4 py-2 text-sm text-gray-400 hover:text-white transition-colors">
              View All
            </button>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default AttendanceReportsPage;
